
export default {
    props: {
        initialQuery: {
            type: String,
            default: ''
        },
        value: {
            type: [String, Number, Object],
            default: () => ({})
        },
        minQuery: {
            type: Number,
            default: 0
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        readonly: {
            type: Boolean,
            default: false,
        },
        placeholder: {
            type: String,
            default: 'Space Force',
        },
        btnLabel: {
            type: String,
            default: 'Find & Verify Group'
        },
        helpText: {
            type: String,
            default: null,
        },
        nonParticipatingAlert: {
            type: Boolean,
            default: true
        },
        levels: {
            type: Array,
            default: () => ['paying', 'financial_advisor', 'dpc']
        }
    }
}
